import React from "react";
import { put } from "../../utils/api";
import GenericViewDrawer1 from "./GenericViewDrawer1";

const PurchaseGoodsView = ({
  open,
  onClose,
  data,
  setsnackOpen,
  fetchDataCallback,
  apiUrl,
}) => {
  if (!data) return null;

  const handleApprovalAction = async (action) => {
    try {
      const response = await put(`${apiUrl}/${data._id}`, {
        approvalStatus: action === "approve" ? "Accepted" : "Rejected",
      });
      if (response?.data) {
        setsnackOpen({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchDataCallback();
        onClose();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error.message || "An error occurred",
        severity: "error",
      });
    }
  };
  const fields = [
    {
      label: "Consumption Month",
      previous: `${data?.consumptionPeriod?.month}/${data?.consumptionPeriod?.year}`,
      requested: `${data?.editValue?.consumptionPeriod?.month || "—"}/${
        data?.editValue?.consumptionPeriod?.year || "—"
      }`,
    },
    {
      label: "Vendor",
      previous: data?.purchase?.vendorLegalName ?? "—",
      requested: data?.editValue?.equipmentData?.vendorLegalName ?? "—",
    },
    {
      label: "Category Type",
      previous: data?.categoryType ?? "—",
      requested: data?.editValue?.categoryType ?? "—",
    },
    {
      label: "Activity Name",
      previous: data?.activityName ?? "—",
      requested: data?.editValue?.activityName ?? "—",
    },
    {
      label: "Type of Activity",
      previous: data?.typeOfActivity ?? "—",
      requested: data?.editValue?.typeOfActivity ?? "—",
    },
    {
      label: "Amount Spend",
      previous: data?.amountSpend
        ? `${data.amountSpend.value} ${data.amountSpend.currency}`
        : "—",
      requested: data?.editValue?.amountSpend
        ? `${data.editValue.amountSpend.value} ${data.editValue.amountSpend.currency}`
        : "—",
    },
    {
      label: "Quantity Bought",
      previous: data?.quantityBought
        ? `${data.quantityBought.value} ${data.quantityBought.unit}`
        : "—",
      requested: data?.editValue?.quantityBought
        ? `${data.editValue.quantityBought.value} ${data.editValue.quantityBought.unit}`
        : "—",
    },
    {
      label: "Remark",
      previous: data?.remark ?? "—",
      requested: data?.editValue?.remark ?? "—",
    },
  ];

  return (
    <GenericViewDrawer1
      open={open}
      onClose={onClose}
      title="Purchase Goods"
      fields={fields}
      documentsField={{
        label: "Documents",
        previous: data?.documents,
        requested: data?.editValue?.documents,
      }}
      timeline={data?.timeLine}
      editRemarkReason={data?.editRemarkReason}
      onApprove={() => handleApprovalAction("approve")}
      onReject={() => handleApprovalAction("reject")}
    />
  );
};

export default PurchaseGoodsView;
